import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { Tabs, Tab } from '@mui/material';

const tabs = {
  FIRST: 'FIRST',
  SECOND: 'SECOND',
  THIRD: 'THIRD',
};

const TabsDemo = () => {
  const [activeTab, setActiveTab] = useState(tabs.FIRST);

  return (
    <Card className={`table-card-style`}>
      <Card.Header className="table-card-header-style">
        <Card.Title className="d-flex gap-3 align-items-center">
          Tabovi
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Tabs
          value={activeTab}
          variant="scrollable"
          scrollButtons="auto"
          onChange={(event, newValue) => setActiveTab(newValue)}
        >
          <Tab label={'Standardi'} value={tabs.FIRST} />
          <Tab label={'Prijava Autora'} value={tabs.SECOND} />
          <Tab label={'Vođenje evidencije Autora'} value={tabs.THIRD} />
        </Tabs>
      </Card.Body>
    </Card>
  );
};

export default TabsDemo;
